var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58579 4.58579L2.41421 3.41421C0.96116 1.96116 0.234633 1.23463 0.490334 0.617317C0.746035 0 1.7735 0 3.82843 0H6.17157C8.2265 0 9.25397 0 9.50967 0.617317C9.76537 1.23463 9.03884 1.96116 7.58578 3.41422L6.41421 4.58579C5.74755 5.25245 5.41421 5.58579 5 5.58579C4.58579 5.58579 4.25245 5.25245 3.58579 4.58579Z",
    fill: "#004E9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownicon);
export default __webpack_public_path__ + "static/media/downicon.88b4523981a0d2a21f7bcd83177db36a.svg";
export { ForwardRef as ReactComponent };